
document.addEventListener('DOMContentLoaded', function() {
    const bigTables = document.querySelectorAll('.big-table');

    const updateTableWidths = () => {
        bigTables.forEach(bigTable => {
            const table = bigTable.querySelector('table');
            if (!table) return;

            const firstRow = table.querySelector('tr');
            if (!firstRow) return;

            const cells = firstRow.querySelectorAll('td');
            if (cells.length < 3) return;

            const tableWidth = table.offsetWidth;

            // Get widths of first three cells
            const cellWidths = Array.from(cells)
                .slice(0, 3)
                .map(cell => {
                    const width = cell.offsetWidth;
                    const percentage = (width / tableWidth * 100).toFixed(1);
                    return percentage;
                });

            // Set CSS variables on .big-table
            bigTable.style.setProperty('--cell-1', `${cellWidths[0]}%`);
            bigTable.style.setProperty('--cell-2', `${cellWidths[1]}%`);
            bigTable.style.setProperty('--cell-3', `${cellWidths[2]}%`);
        });
    };

    // Initial calculation
    updateTableWidths();

    // Update on window resize using debounce for better performance
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateTableWidths, 250);
    });
});
